const EventTypes = {
    OPEN_SIDEBAR: 'OPEN_SIDEBAR',
    CLOSE_SIDEBAR: 'CLOSE_SIDEBAR',
    RESIZE_WINDOW: 'RESIZE_WINDOW',
}

export default EventTypes;
